import * as Yup from 'yup';
import {
    AGREE_TYPE_SALE,
    PASSWORD_REG_EXP,
} from "../../../constant/Constants";
import {
    IS_REQUIRED_MESSAGE,
    MAX_MESSAGE,
} from "../../../constant/utils";
let yourDate = new Date();
let minDate = yourDate.toISOString().split("T")[0];


export const loadMoneyKitScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error for ${src}`));

    document.body.appendChild(script);
  });
};

export const BUSSINESS_INFO_SCHEMA = Yup.object().shape({
    business_name: Yup.string()
        .max(100, MAX_MESSAGE("Business Name", 100))
        .nullable(),
    business_phone_no: Yup.string()
        .min(15, "Phone number is not valid")
        .nullable(),
});

export const ACCOUNT_INFO_SCHEMA = Yup.object().shape({
    old_password: Yup.string()
        .when("new_password", {
            is: (newPassword) => newPassword && newPassword.length > 0, // Apply the validation when new_password has a value
            then: Yup.string().required("Password is required"),
        }),
    new_password: Yup.string()
        .matches(
            PASSWORD_REG_EXP,
            "At least 8 char with 1 upper case, 1 lower, 1 special, and 1 number required"
        )
        .required("Password is required"),
    confirm_password: Yup.string()
        .test("passwords-match", "Passwords must match", function (value) {
            return this.parent.new_password === value;
        })
        .required("Password confirmation is required"),
});


export const SHIP_BILL_SCHEMA = Yup.object().shape({
    customer_shipping_details: Yup.object().shape({
        name: Yup.string()
            .required(IS_REQUIRED_MESSAGE("Name"))
            .nullable(),
        company_name: Yup.string()
            .required(IS_REQUIRED_MESSAGE("Business Name"))
            .nullable(),
        telephone_num: Yup.string()
            .min(17, "Phone number is not valid")
            .required(IS_REQUIRED_MESSAGE("Phone number"))
            .nullable(),
        address: Yup.string()
            .required(IS_REQUIRED_MESSAGE("Address"))
            .nullable(),
        tax_jurisdiction: Yup.string()
            .required(IS_REQUIRED_MESSAGE("Tax Jurisdiction"))
            .nullable(),
        zip_code: Yup.string()
            .required(IS_REQUIRED_MESSAGE("zip code"))
            .nullable(),
        country: Yup.string()
            .required(IS_REQUIRED_MESSAGE("Country"))
            .nullable(),
        city: Yup.string()
            .required(IS_REQUIRED_MESSAGE("City"))
            .nullable(),
        state: Yup.string()
            .required(IS_REQUIRED_MESSAGE("State"))
            .nullable(),
    }),
    customer_billing_details: Yup.object().when(
        "customer_shipping_details",
        {
            is: (value) =>
                value.is_billing_same === AGREE_TYPE_SALE.Yes.value,
            then: Yup.object(),
            otherwise: Yup.object().shape({
                name: Yup.string()
                    .required(IS_REQUIRED_MESSAGE("Name"))
                    .nullable(),
                company_name: Yup.string()
                    .required(IS_REQUIRED_MESSAGE("Business Name"))
                    .nullable(),
                telephone_num: Yup.string()
                    .min(17, "Phone number is not valid")
                    .required(IS_REQUIRED_MESSAGE("Phone number"))
                    .nullable(),
                address: Yup.string()
                    .required(IS_REQUIRED_MESSAGE("Address"))
                    .nullable(),
                zip_code: Yup.string()
                    .required(IS_REQUIRED_MESSAGE("zip code"))
                    .nullable(),
                country: Yup.string()
                    .required(IS_REQUIRED_MESSAGE("Country"))
                    .nullable(),
                city: Yup.string()
                    .required(IS_REQUIRED_MESSAGE("City"))
                    .nullable(),
                state: Yup.string()
                    .required(IS_REQUIRED_MESSAGE("State"))
                    .nullable(),
            }),
        }
    ),



});

export const license = Yup.lazy((values) => 
  Yup.object().shape({
    business_certificate_expiry: Yup.string()
    .when([], (v, {originalValue}) => {
      if (values.business_certificate || values.business_certificate_num) {
        return Yup.string().required().label("Business Certificate Expiry").nullable();
      } else return Yup.date().min(minDate, "expiry date cannot be before todays date").typeError("Select valid date.").nullable();
    }),
    business_certificate_num: Yup.string()
    .when([], (v,{originalValue}) => {
      if (values.business_certificate || values.business_certificate_expiry) {
        return Yup.string().trim().required().label("Business Certificate Number").nullable();
      } else return Yup.string().nullable();
    }),
    // Commeting this validation for now as Per POs suggestions
    // business_certificate: Yup.string()
    // .when([], (v,{originalValue}) => {
    //   if (values.business_certificate_num || values.business_certificate_expiry) {
    //     return Yup.string().required().label("Business Certificate").nullable();
    //   } else return Yup.mixed().nullable();
    // }),
    tobacco_license_expiry:Yup.string()
    .when([], (v, {originalValue}) => {
      if (values.tobacco_license || values.tobacco_license_num) {
        return Yup.string().required().label("Tobacco Certificate Expiry").nullable();
      } else return Yup.date().min(minDate, "expiry date cannot be before todays date").typeError("Select valid date.").nullable();
    }),
    tobacco_license_num: Yup.string()
    .when([], (v,{originalValue}) => {
      if (values.tobacco_license || values.tobacco_license_expiry) {
        return Yup.string().trim().required().label("Tobacco Certificate Number").nullable();
      } else return Yup.string().nullable();
    }),
    // tobacco_license: Yup.string()
    // .when([], (v,{originalValue}) => {
    //   if (values.tobacco_license_num || values.tobacco_license_expiry) {
    //     return Yup.string().required().label("Tobacco Certificate").nullable();
    //   } else return Yup.mixed().nullable();
    // }),
  
    resale_certificate_expiry: Yup.string()
    .when([], (v, {originalValue}) => {
      if (values.resale_certificate || values.resale_certificate_num) {
        return Yup.string().required().label("Resale Certificate Expiry").nullable();
      } else return Yup.date().min(minDate, "expiry date cannot be before todays date").typeError("Select valid date.").nullable();
    }),
    resale_certificate_num: Yup.string()
    .when([], (v,{originalValue}) => {
      if (values.resale_certificate || values.resale_certificate_expiry) {
        return Yup.string().trim().required().label("Resale Certificate Number").nullable();
      } else return Yup.string().nullable();
    }),
    // resale_certificate: Yup.string()
    // .when([], (v,{originalValue}) => {
    //   if (values.resale_certificate_num || values.resale_certificate_expiry) {
    //     return Yup.string().required().label("Resale Certificate").nullable();
    //   } else return Yup.mixed().nullable();
    // }),
    
    // state_id_license:Yup.string()
    // .when([], (v,{originalValue}) => {
    //   if (values.state_id_license_num || values.state_id_license_expiry) {
    //     return Yup.string().required().label("State ID Certificate").nullable();
    //   } else return Yup.mixed().nullable();
    // }),
    state_id_license_expiry:Yup.string()
    .when([], (v, {originalValue}) => {
      if (values.state_id_license || values.state_id_license_num) {
        return Yup.string().required().label("State ID Certificate Expiry").nullable();
      } else return Yup.date().min(minDate, "expiry date cannot be before todays date").typeError("Select valid date.").nullable();
    }),
    state_id_license_num:Yup.string()
    .when([], (v,{originalValue}) => {
      if (values.state_id_license || values.state_id_license_expiry) {
        return Yup.string().trim().required().label("State ID Certificate Number").nullable();
      } else return Yup.string().nullable();
    }),
    customer_other_licenses: values.customer_other_licenses?.length > 0
      ? Yup.array().of(
          Yup.object().shape({
            name: Yup.string().required(IS_REQUIRED_MESSAGE("Name")),
            number: Yup.string().trim().required(IS_REQUIRED_MESSAGE("Number")),
            expiry_date: Yup.date().required(IS_REQUIRED_MESSAGE("Expiry Date")),
            file: Yup.mixed().required(IS_REQUIRED_MESSAGE("File")),
          })
        )
      : Yup.array(),
  })
);
